// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimAdjudicationResponseLineItemAdjudicationCode {
    'carc'?: string;
    'rarc'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimAdjudicationResponseLineItemAdjudicationCode>> = [
        {
            "name":     "carc",
            "baseName": "carc",
            "type":     "string"
        },
        {
            "name":     "rarc",
            "baseName": "rarc",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimAdjudicationResponseLineItemAdjudicationCode.attributeTypeMap;
    }
}
